var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "columns is-multiline" },
    [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.category.name) + " "),
              _vm.attachments.length > 0
                ? _c("span", {
                    staticClass:
                      "has-badge-rounded has-badge-info has-badge-large pl-3",
                    attrs: { "data-badge": _vm.attachments.length },
                  })
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c(
              "p",
              { staticClass: "buttons" },
              [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Email" },
                    on: {
                      click: function ($event) {
                        return _vm.openEmailModal()
                      },
                    },
                  },
                  [_vm._m(0)]
                ),
                _c("agent-scan-button", {
                  on: { "scan-results": (e) => _vm.handleScanResult(e) },
                }),
                _c(
                  "a",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Refresh" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("image-uploaded")
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
                _c(
                  "a",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Select all" },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedStatusAll(true)
                      },
                    },
                  },
                  [_vm._m(2)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Deselect all" },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedStatusAll(false)
                      },
                    },
                  },
                  [_vm._m(3)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Copy to quote" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleCopyAttachmentModal(true)
                      },
                    },
                  },
                  [_vm._m(4)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Delete selected" },
                    on: { click: _vm.showDeleteAllModal },
                  },
                  [_vm._m(5)]
                ),
                _c(
                  "confirm-modal",
                  {
                    attrs: {
                      active: _vm.isDeleteAllModalActive,
                      "ok-text": "Yes",
                      "cancel-text": "No",
                    },
                    on: {
                      "update:active": function ($event) {
                        _vm.isDeleteAllModalActive = $event
                      },
                      ok: function ($event) {
                        return _vm.deleteSelectedAttachments(true)
                      },
                      cancel: function ($event) {
                        return _vm.deleteSelectedAttachments(false)
                      },
                    },
                  },
                  [
                    _c(
                      "p",
                      { attrs: { slot: "text-title" }, slot: "text-title" },
                      [_vm._v("Delete attachments")]
                    ),
                    _c(
                      "p",
                      { attrs: { slot: "text-content" }, slot: "text-content" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "has-text-primary has-text-weight-bold",
                          },
                          [_vm._v(_vm._s(_vm.selectedAttachments.length))]
                        ),
                        _vm._v(
                          " selected attachments will be deleted. Continue? "
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Download selected" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadSelectedAttachments()
                      },
                    },
                  },
                  [_vm._m(6)]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          [
            _c(
              "draggable",
              {
                staticClass: "columns is-multiline",
                attrs: { list: _vm.attachments, group: "attachments" },
                on: {
                  change: (event) => _vm.attachmentChange(_vm.category, event),
                },
              },
              [
                _vm._l(_vm.attachments, function (attachment) {
                  return _c(
                    "div",
                    {
                      key: attachment.quoteAttachmentId,
                      staticClass: "column is-1 m-0 p-1",
                    },
                    [
                      _c("QuoteAttachment", {
                        attrs: {
                          attachment: attachment,
                          "quote-id": _vm.quoteId,
                          "quote-attachment-category-id":
                            _vm.category.quoteAttachmentCategoryId,
                          "quote-attachment-id": attachment.quoteAttachmentId,
                          categories: _vm.categories,
                        },
                        on: {
                          "update:attachment": (e) =>
                            _vm.handleAttachmentChange(e, attachment),
                          "image-uploaded": function ($event) {
                            return _vm.imageUpdated()
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "column is-3 m-0 p-1" },
                  [
                    _c("file-drop-zone", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "quote-id": _vm.quoteId,
                        "default-size": 128,
                        "quote-attachment-category-id":
                          _vm.category.quoteAttachmentCategoryId,
                        "additional-classes": "quote-attachment-dropzone",
                      },
                      on: {
                        "image-uploaded": function ($event) {
                          return _vm.imageUpdated()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c(
        "vue-email-modal",
        {
          attrs: {
            active: _vm.isEmailModalActive,
            "icon-name": "mdi-email-open",
            "icon-type": "primary",
            "enable-send": _vm.enableSend && !_vm.isImageAttachActive,
            "enable-attach": false,
            "toggle-attach-button": false,
          },
          on: {
            "update:active": function ($event) {
              _vm.isEmailModalActive = $event
            },
            send: _vm.sendEmail,
            discard: _vm.discardEmail,
            attach: _vm.attachMedia,
            "show-attach": false,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "text-content" }, slot: "text-content" },
            [
              _vm.isEmailModalActive
                ? _c("vue-email", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isImageAttachActive,
                        expression: "!isImageAttachActive",
                      },
                    ],
                    ref: "emailer",
                    attrs: {
                      "quote-attachments": _vm.allSelectedAttachments,
                      "asset-id": _vm.emailer?.assetId,
                    },
                    on: { "new-email": true, sent: _vm.sent },
                    model: {
                      value: _vm.emailer,
                      callback: function ($$v) {
                        _vm.emailer = $$v
                      },
                      expression: "emailer",
                    },
                  })
                : _vm._e(),
              _vm.emailer && _vm.isImageAttachActive
                ? _c("image-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isImageAttachActive,
                        expression: "isImageAttachActive",
                      },
                    ],
                    attrs: {
                      "quote-id": _vm.emailer.assetId,
                      "quote-ids": _vm.quoteIds,
                    },
                    model: {
                      value: _vm.selectedImages,
                      callback: function ($$v) {
                        _vm.selectedImages = $$v
                      },
                      expression: "selectedImages",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.isCopyImageModalActive
        ? _c("quote-no-search-modal", {
            attrs: { active: _vm.isCopyImageModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isCopyImageModalActive = $event
              },
              copy: function ($event) {
                return _vm.copyQuoteAttachmentToOtherQuote($event)
              },
              close: function ($event) {
                return _vm.toggleCopyAttachmentModal(false)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-email-fast mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-content-copy mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete-sweep mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-download mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }